import { render, staticRenderFns } from "./TextareaV1Properties.vue?vue&type=template&id=ed99e394&"
import script from "./TextareaV1Properties.vue?vue&type=script&lang=js&"
export * from "./TextareaV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports